(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results-appliance-barn"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"] && !Shopify.designMode) return;
  try {
    

  /*

   * THE APPLIANCE BARN

   * Search results guard

   *

   * Search results on this store are product-only.

   * Keep type=product in the URL so Shopify paginates products rather

   * than paginating a mixed products/pages/articles result set.

   */

  (() => {

    const url = new URL(window.location.href);



    if (url.pathname === '/search' && url.searchParams.get('q')) {

      if (url.searchParams.get('type') !== 'product') {

        url.searchParams.set('type', 'product');

        window.location.replace(url.toString());

        return;

      }

    }



    if (url.hash) {

      document.addEventListener(

        'DOMContentLoaded',

        () => {

          const card = document.getElementById(url.hash.slice(1));



          if (card) {

            card.scrollIntoView({ behavior: 'instant' });

          }

        },

        { once: true }

      );

    }

  })();


  } catch(e) { console.error(e); }
})();
})();
